import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useCategories = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [CategoriesList, setCategoriesList] = useState([]);
  const fetchData = async (channelId, countryCode) => {
    try {
      setIsLoading(true);
      const {data} = await axios.post(`saas/shop/get-categories`, {
        channel: channelId,
        countryCode
      });
      setCategoriesList(data);
      return {categoriesList: data};
    } catch (error) {
      handleError(error);
      return {categoriesList: []};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    categoriesList: CategoriesList
  };
};
export const useCategoriesModel = createModel(useCategories);
